module.exports = __webpack_public_path__ + "static/media/ic-block-red.853a2fa8.svg";